import React from 'react';

export default class ShNews extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.ref.current.news = this.props.listing.news;
  }

  render() {
    return (
      <sh-news ref={this.ref}></sh-news>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/listing-detail/sh-wrappers/sh-news.js